import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GeneralService } from '../services/general.service';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { DateService } from '../services/date.service';
@Component({
  selector: 'app-avt-liste-document',
  templateUrl: './avt-liste-document.component.html',
  styleUrls: ['./avt-liste-document.component.scss'],
})
export class AvtListeDocumentComponent implements OnInit {
  constructor(
    public router: Router,
    public generalService: GeneralService,
    public route: ActivatedRoute,
    public dateService: DateService
  ) {}

  //fenetre == "1" facture
  //fenetre == "2" commande
  //fenetre == "3" dvis
  //fenetre == "4" bon de livraison
  fenetre: string;
  //affichage modale ou ordinaire
  mode: string;
  exist: boolean = false;
  columnsDocument;
  columns = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Num',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_RS',
        Lg_Code: '',
        TableRD_Des: 'Client',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Date',
        Lg_Code: '',
        TableRD_Des: 'Date',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_THT',
        Lg_Code: '',
        TableRD_Des: 'Montant HT',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  columnsFacture = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Num',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_RS',
        Lg_Code: '',
        TableRD_Des: 'Client',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Date',
        Lg_Code: '',
        TableRD_Des: 'Date',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_THT',
        Lg_Code: '',
        TableRD_Des: 'Montant HT',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Reliquat',
        Lg_Code: '',
        TableRD_Des: 'Reliquat',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'state',
        Lg_Code: '',
        TableRD_Des: 'État',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 7,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  date_Debut: Date;
  date_Fin: Date;
  nomFenetre: string;
  @ViewChild('listeDocumentComponen', { static: false })
  listeDocumentComponen: AvtListesComponent;
  listeDocument = [];
  reglerOrNot: string = '0';
  // la fenetre liste dcument peut etre ouvert par le composons avtActionComponont ppour rechercher un don de cmmande
  // dans se k il faus masquer les bouton modifier et consuter
  showButton: boolean = true;
  showDocument: boolean = false;
  random: string;
  ngOnInit() {
    this.readParamUrl();
  }
  exportToExcel() {
    this.generalService.exportToExcel(
      this.listeDocumentComponen,
      'LISTE' + this.nomFenetre.toUpperCase()
    );
  }
  init() {
    this.exist = false;
    this.initDate();
    this.setNomDoc();
    this.getListeDocument();
  }
  goToDocument(typeTrs) {
    if (this.listeDocumentComponen.row != undefined) {
      var num = '';
      // if(this.fenetre == "1")
      //   num = this.listeDocumentComponen.row.P_Num;
      // else
      num = this.listeDocumentComponen.row.Doc_Num;
      this.generalService.popupCenter(
        '/w/avt/document/' + num + '/' + typeTrs + '/' + this.fenetre
      );
      // this.router.navigate(["avt/document",num,typeTrs,this.fenetre])
    } else
      this.generalService.dialogSuccess(
        'Veillez sélectionner une ligne',
        false
      );
  }
  initDate() {
    this.date_Debut = new Date();
    this.date_Debut.setMonth(this.date_Debut.getMonth() - 2);
    this.date_Debut.setDate(1);
    this.date_Fin = new Date();
    this.date_Fin.setMonth(this.date_Fin.getMonth() + 2);
    this.date_Fin.setDate(1);
  }

  getListeDocument() {
    this.exist = false;
    var url = this.getUrl();
    this.generalService.rechercheTable(url).subscribe((listeDocument) => {
      if (this.fenetre == '1') {
        this.columnsDocument = this.columnsFacture;
        this.listeDocument =
          this.generalService.genererListeDocument(listeDocument);
      } else {
        this.columnsDocument = this.columns;
        this.listeDocument = listeDocument;
      }
      this.showDocument = true;
      this.exist = true;
      setTimeout(() => {
        this.listeDocumentComponen.setDataSource(this.listeDocument);
      }, 100);
    });
  }

  getUrl() {
    var paramDate =
      this.dateService.setFormatDateRechercheServer(this.date_Debut) +
      ',' +
      this.dateService.setFormatDateRechercheServer(this.date_Fin);
    var url = this.generalService.url;
    //fenetre == "1" facture
    if (this.fenetre == '1') {
      //url += "FACT," + this.dateService.setFormatDateRechercheServer( this.date_Debut)+","+this.dateService.setFormatDateRechercheServer( this.date_Fin);
      // if(this.reglerOrNot =="0")
      //   url +=  "avtPieceTAll&param=" + paramDate;
      // if(this.reglerOrNot =="1")
      //   url +=  "avtPieceTRegler&param=" + paramDate;
      // if(this.reglerOrNot =="2")
      //   url +=  "avtPieceTNonRegler&param=" + paramDate;

      url +=
        'avtdoc&param=FACT,' +
        this.dateService.setFormatDateRechercheServer(this.date_Debut) +
        ',' +
        this.dateService.setFormatDateRechercheServer(this.date_Fin);
    }
    //fenetre == "2" commande
    if (this.fenetre == '2') {
      url +=
        'avtdoc&param=CMD,' +
        this.dateService.setFormatDateRechercheServer(this.date_Debut) +
        ',' +
        this.dateService.setFormatDateRechercheServer(this.date_Fin);
    }
    //fenetre == "3" devis
    if (this.fenetre == '3') {
      url +=
        'avtdoc&param=FACP,' +
        this.dateService.setFormatDateRechercheServer(this.date_Debut) +
        ',' +
        this.dateService.setFormatDateRechercheServer(this.date_Fin);
    }
    //fenetre == "4" bon de livraison
    if (this.fenetre == '4') {
      url +=
        'avtdoc&param=BLC,' +
        this.dateService.setFormatDateRechercheServer(this.date_Debut) +
        ',' +
        this.dateService.setFormatDateRechercheServer(this.date_Fin);
    }
    //fenetre == "5" Avoir
    if (this.fenetre == '5') {
      url +=
        'avtdoc&param=AVC,' +
        this.dateService.setFormatDateRechercheServer(this.date_Debut) +
        ',' +
        this.dateService.setFormatDateRechercheServer(this.date_Fin);
    }
    return url;
  }
  setNomDoc() {
    //facture fenetre == "1"
    if (this.fenetre == '1') {
      this.nomFenetre = 'factures';
    }
    if (this.fenetre == '2') {
      this.nomFenetre = 'commandes';
    }
    if (this.fenetre == '3') {
      this.nomFenetre = 'devis';
    }
    if (this.fenetre == '4') {
      this.nomFenetre = 'bons de livraison';
    }
    if (this.fenetre == '5') {
      this.nomFenetre = 'Avoirs';
    }
  }
  // cette evennement pour utile pour la recherche d'un document
  // elle est utiliser par dotre composons
  choisirDocument() {
    if (this.generalService.isNotEmpty(this.listeDocumentComponen.row)) {
      this.generalService.rowChoisie = this.listeDocumentComponen.row;
      this.generalService.dialog.closeAll();
      if (this.mode == 'modal') {
        localStorage.setItem(
          this.random,
          JSON.stringify(this.listeDocumentComponen.row)
        );
        window.close();
      }
    } else
      this.generalService.dialogSuccess(
        'Veillez sélectionner une ligne',
        false
      );
  }
  closeWindow() {
    window.close();
  }
  onEtatChange() {}
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.showDocument = false;
      this.fenetre = params['fenetre'];
      this.mode = params['mode'];
      this.random = params['random'];
      if (!this.generalService.isNotEmpty(this.mode)) this.mode = 'ordinaire';
      else this.showButton = false;
      if (!this.generalService.isNotEmpty(this.fenetre)) {
        this.showButton = false;
        this.fenetre = this.generalService.fenetreAvtListeDocument;
      }
      this.init();
    });
  }
}
